import cn from 'classnames';
import { useContext } from 'react';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import Logo from 'components/signUpFunnel/Logo';
import { BrandContext, TEMPO } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import useBrand from 'hooks/useBrand';

const MobileFooter = () => {
  const isTempo = useBrand(TEMPO);
  const { brand } = useContext(BrandContext);

  if (!brand) return null;

  return (
    <div
      className={cn('max-w-$bp1 flex max-w-550 flex-row-reverse	justify-between', {
        'px-8': !isTempo,
        'pl-6 pr-8': isTempo,
      })}
    >
      <div
        className={cn({
          'mx-auto flex-auto': !isTempo,
          'mr-10': isTempo,
        })}
      >
        <Text className="pt-4 text-right text-sm leading-4">
          Questions?
          <DefaultLink
            isExternal
            to={`tel:${brandData(brand).supportPhoneNumber.replace(/[^a-zA-Z0-9]/g, '')}`}
            className="p-0 pl-1 text-sm font-normal"
          >
            {brandData(brand)?.supportPhoneNumber}
          </DefaultLink>
        </Text>
        <Text className="pt-1 text-right text-sm leading-4">Mon - Fri 9AM - 6PM CT</Text>
      </div>
      <div className="mt-4">
        <Logo />
      </div>
    </div>
  );
};

export default MobileFooter;
